module.exports = __webpack_public_path__ + "img/header-ar.97df2846.jpg";